import React, { useEffect } from 'react';
import { Router, globalHistory } from '@reach/router';
import Album from '../components/pages/gallery/Album';
import Photo from '../components/pages/gallery/Photo';
import MemberAlbum from '../components/pages/member-only/gallery/Album';
import MemberPhoto from '../components/pages/member-only/gallery/Photo';
import AboutUs from '../components/pages/about-us/List';
import AboutUsContent from '../components/pages/about-us/Content';
import WhatsNew from '../components/pages/news/List';
import WhatsNewContent from '../components/pages/news/Content';
import EHealth from '../components/pages/e-health/List';
import EHealthContent from '../components/pages/e-health/Content';
import Doctor from '../components/pages/doctors/List';
import DoctorContent from '../components/pages/doctors/Content';
import Home from '../components/pages/home';
import Hospital from '../components/pages/hospital/List';
import HospitalContent from '../components/pages/hospital/Content';
import EDrugHome from '../components/pages/e-pharm/home';
import EDrugDrugSearch from '../components/pages/e-pharm/drug-search/List';
import EDrugDrugSearchContent from '../components/pages/e-pharm/drug-search/Content';
import EDrugSales from '../components/pages/e-pharm/sales/List';
import EDrugSalesContent from '../components/pages/e-pharm/sales/Content';
import EDrugNewDrugs from '../components/pages/e-pharm/new-drugs/List';
import EDrugNewDrugsContent from '../components/pages/e-pharm/new-drugs/Content';
import EDrugEvents from '../components/pages/e-pharm/events/List';
import EDrugEventsContent from '../components/pages/e-pharm/events/Content';
import EDrugEventsCheckout from '../components/pages/e-pharm/events/Checkout';
import EDrugSpecialOffers from '../components/pages/e-pharm/spacial-offers/List';
import EDrugSpecialOffersContent from '../components/pages/e-pharm/spacial-offers/Content';
import EDrugSuppliers from '../components/pages/e-pharm/suppliers/List';
import EDrugSuppliersContent from '../components/pages/e-pharm/suppliers/Content';
import EDrugTools from '../components/pages/e-pharm/tools/Tools';
import EDrugLinks from '../components/pages/e-pharm/links/links';
import MediaRelease from '../components/pages/media-release/List';
import MediaReleaseContent from '../components/pages/media-release/Content';
import MemberOnlyHome from '../components/pages/member-only/home';
import MemberOnlyNews from '../components/pages/member-only/news/List';
import MemberOnlyNewsContent from '../components/pages/member-only/news/Content';
import MemberOnlyCard from '../components/pages/member-only/Card';
import CMEHome from '../components/pages/cme/home';
import CMEVideos from '../components/pages/cme/video/List';
import CMEVideoContent from '../components/pages/cme/video/Content';
import CMEGuidelineList from '../components/pages/cme/guideline/List';
import CMEGuidelineContent from '../components/pages/cme/guideline/Content';
import CMEEvents from '../components/pages/cme/events/List';
import CMEEventsContent from '../components/pages/cme/events/Content';
import CMEEventsCheckout from '../components/pages/cme/events/Checkout';
import CMEEventOrganizers from '../components/pages/cme/event-organizers/List';
import CMEEventOrganizersContent from '../components/pages/cme/event-organizers/Content';
import CMEQuizzes from '../components/pages/cme/quizzes/List';
import CMEQuizzesContent from '../components/pages/cme/quizzes/Content';
import CMELinks from '../components/pages/cme/links/links';
import MemberOnlyHKDUEvents from '../components/pages/member-only/events/List';
import MemberOnlyHKDUEventsContent from '../components/pages/member-only/events/Content';
import MemberOnlyHKDUEventsCheckout from '../components/pages/member-only/events/Checkout';
import MemberOnlyMembers from '../components/pages/member-only/members/List';
import MemberOnlyMembersContent from '../components/pages/member-only/members/Content';
import MemberOnlyMaterials from '../components/pages/member-only/materials/List';
import MemberOnlyMaterialsContent from '../components/pages/member-only/materials/Content';
import MemberOnlyTools from '../components/pages/member-only/tools/tools';
import Links from '../components/pages/links/links';
import Downloads from '../components/pages/downloads/downloads';
import ApplyMember from '../components/pages/memberApply/ApplyMember';
import Thankyou from '../components/pages/memberApply/Thankyou';
import PrivateRoute from '../components/PrivateRoute';
import { DOCTOR, MEMBER, OWNER, SUPPLIER } from '../constants/rule';
import { AUTH_TOKEN } from '../constants';
import PageNotFound from '../components/pages/error/404';
import Error from '../components/pages/error/error';
import { QueryParamProvider } from 'use-query-params';

const IndexPage = () => {
  useEffect(() => {
    const url = new URL(window.location);
    if (url.searchParams.has('token')) {
      const token = url.searchParams.get('token');
      localStorage.setItem(AUTH_TOKEN, token);
      url.searchParams.delete('token');
      window.location.assign(url);
    }
  }, []);

  return (
    <QueryParamProvider reachHistory={globalHistory}>
      <Router>
        <Home path="/public" />
        <Album path="/public/gallery" />
        <Photo path="/public/gallery/:id" />
        <AboutUs path="/public/about-us" />
        <AboutUsContent path="/public/about-us/:id" />
        <WhatsNew path="/public/news" />
        <WhatsNewContent path="/public/news/:id" />
        <EHealth path="/public/e-health" />
        <EHealthContent path="/public/e-health/:id" />
        <Doctor path="/public/doctors" />
        <DoctorContent path="/public/doctors/:id" />
        <Hospital path="/public/hospital" />
        <HospitalContent path="/public/hospital/:id" />
        <MediaRelease path="/public/media-release" />
        <MediaReleaseContent path="/public/media-release/:id" />
        <Links path="/public/links" />
        <Downloads path="/public/downloads" />
        <ApplyMember path="/public/apply" />
        <Thankyou path="/public/apply/thanks" />
        <PrivateRoute path="/cme" roles={[MEMBER, OWNER, DOCTOR]}>
          <CMEHome path="/" />
          <CMEEvents path="events" />
          <CMEEventsContent path="events/:id" />
          <CMEEventsCheckout path="events/checkout/:id" />
          <CMEEventOrganizers path="event-organizers" />
          <CMEEventOrganizersContent path="event-organizers/:id" />
          <CMEQuizzes path="quizzes" />
          <CMEQuizzesContent path="quizzes/:id" />
          <CMEVideos path="videos" />
          <CMEVideoContent path="videos/:id" />
          <CMEGuidelineList path="guidelines" />
          <CMEGuidelineContent path="guidelines/:id" />
          <CMELinks path="links" />
        </PrivateRoute>
        <PrivateRoute path="/e-pharm" roles={[MEMBER, OWNER, DOCTOR, SUPPLIER]}>
          <EDrugHome path="/" />
          <EDrugDrugSearch path="/drug-search" />
          <EDrugDrugSearchContent path="/drug-search/:id" />
          <EDrugSales path="drug-news" />
          <EDrugSalesContent path="drug-news/:id" />
          <EDrugNewDrugs path="new-drugs" />
          <EDrugNewDrugsContent path="new-drugs/:id" />
          <EDrugEvents path="events" />
          <EDrugEventsContent path="events/:id" />
          <EDrugEventsCheckout path="events/checkout/:id" />
          <EDrugSpecialOffers path="special-offers" />
          <EDrugSpecialOffersContent path="special-offers/:id" />
          <EDrugSuppliers path="pharm-dir" />
          <EDrugSuppliersContent path="pharm-dir/:id" />
          <EDrugTools path="tools" />
          <EDrugLinks path="links" />
        </PrivateRoute>
        <PrivateRoute path="/member-only" roles={[MEMBER, OWNER]}>
          <MemberOnlyHome path="/" />
          <MemberOnlyNews path="news" />
          <MemberOnlyNewsContent path="news/:id" />
          <MemberOnlyCard path="member-card" />
          <MemberOnlyHKDUEvents path="events" />
          <MemberOnlyHKDUEventsContent path="events/:id" />
          <MemberOnlyHKDUEventsCheckout path="events/checkout/:id" />
          <MemberAlbum path="album" />
          <MemberPhoto path="album/:id" />
          <MemberOnlyMembers path="members" />
          <MemberOnlyMembersContent path="members/:id" />
          <MemberOnlyMaterials path="knowledge-materials" />
          <MemberOnlyMaterialsContent path="knowledge-materials/:id" />
          <MemberOnlyTools path="tools" />
        </PrivateRoute>
        <Error path="/error/:status" />
        <PageNotFound default />
      </Router>
    </QueryParamProvider>
  );
};

export default IndexPage;
